import { useEffect } from "react";
import { useRegisterCustomerAndDeviceMutation } from "../generated/graphql";
import { useAuth } from "../contexts/auth-context";
import { useUpdateProfileMutation } from "../providers/profile";
import { usePushTokenStore } from "../providers/push-token";

const codeBaseVersion = process.env.REACT_APP_PARHATO_CODE_VERSION!;

const useCustomerDeviceRegistration = () => {
  const { user } = useAuth();
  const { pushToken } = usePushTokenStore();
  const [registerCustomerAndDevice] = useRegisterCustomerAndDeviceMutation({
    notifyOnNetworkStatusChange: true,
  });

  const { mutate: updateProfile } = useUpdateProfileMutation();

  useEffect(() => {
    if (user?.token && pushToken && user?.phone) {
      registerCustomerAndDevice({
        variables: {
          customer: {
            email: user.email!,
            firstName: user.firstName,
            lastName: user.lastName,
            phoneNumber: user.phone,
            username: user.userName!,
          },
          device: {
            pushToken: pushToken,
            appVersion: Number(codeBaseVersion),
          },
        },
      });

      updateProfile({
        userId: user?.id!,
        userPayload: {
          email: user.email!,
          firstName: user.firstName,
          lastName: user.lastName,
          phone: user.phone,
          userName: user.userName!,
          fcmToken: pushToken,
          id: user?.id!,
        },
      });
    }
  }, [pushToken, registerCustomerAndDevice, updateProfile, user]);
};

export default useCustomerDeviceRegistration;
